import {
  Box,
  Button,
  CloseButton,
  HStack,
  Tag,
  TagLabel,
  Text,
} from '@chakra-ui/react';

import { useCompanyCompareStore } from '../hooks/useCompanyCompareStore';

export const CompareSelectionTray = () => {
  const currentEmployer = useCompanyCompareStore((s) => s.currentEmployer);
  const selectedCompanies = useCompanyCompareStore((s) => s.selectedCompanies);
  const removeCompany = useCompanyCompareStore((s) => s.removeCompany);
  const clearAll = useCompanyCompareStore((s) => s.clearAll);
  const openDrawer = useCompanyCompareStore((s) => s.openDrawer);

  const allCompanies = currentEmployer
    ? [currentEmployer, ...selectedCompanies]
    : selectedCompanies;

  if (allCompanies.length === 0) return null;

  const totalCount = allCompanies.length;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      boxShadow="0 -2px 10px rgba(0,0,0,0.08)"
      py={3}
      px={6}
      zIndex={100}
    >
      <HStack justify="space-between" align="center" maxW="1400px" mx="auto">
        <HStack spacing={3} flex={1} overflow="hidden">
          <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
            {totalCount} of 4
          </Text>
          <HStack spacing={2} overflow="auto">
            {/* Current employer tag — pinned, not removable */}
            {currentEmployer && (
              <Tag
                size="sm"
                colorScheme="green"
                variant="subtle"
                borderRadius="full"
              >
                <TagLabel>{currentEmployer.name} (You)</TagLabel>
              </Tag>
            )}
            {/* User-selected companies */}
            {selectedCompanies.map((company) => (
              <Tag
                key={company.rcid}
                size="sm"
                colorScheme="blue"
                variant="subtle"
                borderRadius="full"
              >
                <TagLabel>{company.name}</TagLabel>
                <CloseButton
                  size="sm"
                  ml={1}
                  onClick={() => removeCompany(company.rcid)}
                />
              </Tag>
            ))}
          </HStack>
        </HStack>

        <HStack spacing={3}>
          {selectedCompanies.length > 0 && (
            <Button
              size="xs"
              variant="link"
              colorScheme="gray"
              onClick={clearAll}
            >
              Clear added
            </Button>
          )}
          <Button
            size="sm"
            colorScheme="blue"
            onClick={openDrawer}
            isDisabled={totalCount < 2}
          >
            Compare ({totalCount})
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
